import Vue from 'vue'
import Vuex from 'vuex'
import {Progress} from 'vant'

Vue.use(Vuex).use(Progress);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
